export const makeInfo = (pathInfo) => {
  const getRvrSysNm = () => {
    const name = pathInfo.RiverSysNm || ''
    if (name.endsWith('その他')) {
      return ''
    }
    if (name.endsWith('川')) {
      return name + '水系'
    }
    return name
  }
  const getRvrNm = () => {
    const name = pathInfo.RiverNm || ''
    if (name.endsWith('その他')) {
      return ''
    }
    return name
  }
  const rvrSysNm = getRvrSysNm()
  const rvrNm = getRvrNm()
  if (!pathInfo.RiverID2) {
    return (rvrNm ? ` ${rvrNm}` : '') + (pathInfo.Address ? ` (${pathInfo.Address})` : '')
  }
  return (rvrSysNm ? rvrSysNm + (rvrNm ? ` ${rvrNm}` : '') : rvrNm) + (pathInfo.Address ? ` (${pathInfo.Address})` : '')
}

export const setRank = (value, list) => {
  let rank = 0
  if (!value || !list) {
    return rank
  }
  if (list.length === 0) {
    return rank
  }
  list.forEach((item) => {
    if (item.value <= value) {
      rank = item.rank
    }
  })
  return rank
}

export const makeTrueId = (id) => {
  if (id.includes('_')) {
    return 'cctv_' + id
  }
  return id
}

const simpleParseCsv = (csvStr) => {
  const [header, ...lines] = csvStr.trim().split('\n')
  const keys = header.split(',')
  return lines.map((line) => {
    const values = line.split(',')
    return Object.fromEntries(keys.map((k, i) => [k, values[i]]))
  })
}

const createFeature = (lon, lat, row, type, rank) => ({
  type: 'Feature',
  geometry: {
    type: 'Point',
    coordinates: [lon, lat]
  },
  properties: {
    name: row.Name,
    path: row.ID,
    rvr_code: row.RiverID2,
    type,
    rank
  }
})

const processObsPoint = (row, lon, lat, rank, currentPointId, rankZeroFeatures, rankNoneZeroFeatures) => {
  if (rank > 0) {
    rankNoneZeroFeatures.push(createFeature(lon, lat, row, 'obs', rank))
  } else {
    if (currentPointId && row.ID === currentPointId) {
      rankNoneZeroFeatures.push(createFeature(lon, lat, row, 'obs', 0))
    }
    rankZeroFeatures.push(createFeature(lon, lat, row, 'obs', 0))
  }
}

const processCameraFeature = (row, currentPointId, rankZeroFeatures, rankNoneZeroFeatures) => {
  if (
    row.CameraID
    && row.CameraLat
    && row.CameraLon
    && !Number.isNaN(Number.parseFloat(row.CameraLat))
    && !Number.isNaN(Number.parseFloat(row.CameraLon))
  ) {
    const camLon = Number.parseFloat(row.CameraLon)
    const camLat = Number.parseFloat(row.CameraLat)
    rankZeroFeatures.push(createFeature(camLon, camLat, row, 'cam', 0))
    if (currentPointId && row.ID === currentPointId) {
      rankNoneZeroFeatures.push(createFeature(camLon, camLat, row, 'cam', 0))
    }
  }
}

const processCamera = (row, lon, lat, currentPointId, rankZeroFeatures, rankNoneZeroFeatures) => {
  if (currentPointId && row.ID === currentPointId) {
    rankNoneZeroFeatures.push(createFeature(lon, lat, row, 'cam', 0))
  }
  rankZeroFeatures.push(createFeature(lon, lat, row, 'cam', 0))
}

export const makeGeoJson = (csv, waterLevel, currentPointId) => {
  const records = simpleParseCsv(csv)
  const rankMap = new Map(
    (waterLevel || []).map((item) => [item.id, Number(item.rank)])
  )
  const rankZeroFeatures = []
  const rankNoneZeroFeatures = []

  for (const row of records) {
    const lon = Number.parseFloat(row.Lon)
    const lat = Number.parseFloat(row.Lat)
    const typeInt = Number.parseInt(row.Type, 10)
    const rank = rankMap.get(row.ID) || 0

    if (typeInt === 1 || typeInt === 2) {
      processObsPoint(row, lon, lat, rank, currentPointId, rankZeroFeatures, rankNoneZeroFeatures)
      if (typeInt === 2) {
        processCameraFeature(row, currentPointId, rankZeroFeatures, rankNoneZeroFeatures)
      }
    } else if (typeInt === 3) {
      processCamera(row, lon, lat, currentPointId, rankZeroFeatures, rankNoneZeroFeatures)
    }
  }
  const clusteredGeoJson = {
    type: 'FeatureCollection',
    features: rankZeroFeatures
  }
  const unclusteredGeoJson = {
    type: 'FeatureCollection',
    features: rankNoneZeroFeatures
  }
  return { clusteredGeoJson, unclusteredGeoJson }
}

const bezierA = (aA1, aA2) => {
  return 1.0 - 3.0 * aA2 + 3.0 * aA1
}

const bezierB = (aA1, aA2) => {
  return 3.0 * aA2 - 6.0 * aA1
}

const bezierC = (aA1) => {
  return 3.0 * aA1
}

export const cubicBezier = (p1x, p1y, p2x, p2y) => {
  // https://github.com/gre/bezier-easing/blob/master/src/index.js より簡易実装
  function calcBezier(t, aA1, aA2) {
    return ((bezierA(aA1, aA2) * t + bezierB(aA1, aA2)) * t + bezierC(aA1)) * t
  }
  function getSlope(t, aA1, aA2) {
    return 3.0 * bezierA(aA1, aA2) * t * t + 2.0 * bezierB(aA1, aA2) * t + bezierC(aA1)
  }
  function getTforX(aX) {
    let aGuessT = aX
    for (let i = 0; i < 4; ++i) {
      const currentSlope = getSlope(aGuessT, p1x, p2x)
      if (currentSlope === 0.0) return aGuessT
      const currentX = calcBezier(aGuessT, p1x, p2x) - aX
      aGuessT -= currentX / currentSlope
    }
    return aGuessT
  }
  return function (x) {
    return calcBezier(getTforX(x), p1y, p2y)
  }
}
